import React from "react";
import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import GradingIcon from '@mui/icons-material/Grading';
import PanoramaIcon from '@mui/icons-material/Panorama';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BlockIcon from '@mui/icons-material/Block';
import GppBadIcon from '@mui/icons-material/GppBad';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import CampaignIcon from '@mui/icons-material/Campaign';
import StorefrontIcon from '@mui/icons-material/Storefront';

export interface MenuItem {
    Name: string;
    Id: number;
    Rout?: string
    Role: string

    GetIcon?(): React.ReactNode;

    Items?: MenuItem[]
}

export const Menu: MenuItem[] = [
    {
        Id: -10,
        Name: 'Главная',
        Rout: '',
        Role: 'admin.manager',
        GetIcon(): React.ReactNode {
            return <HomeIcon/>
        }
        
    },
    {
        Id: 0,
        Name: 'Пользователи',
        Rout: 'users',
        Role: 'admin.manager',
        GetIcon(): React.ReactNode {
            return <GroupIcon/>
        }
    },
    {
        Id: 10,
        Name: 'Боты',
        Role: 'admin.manager',
        Rout: 'bots',
        GetIcon(): React.ReactNode {
            return <SmartToyIcon/>
        }
    },
    {
        Id: 20,
        Name: 'Прокси',
        Rout: 'proxies',
        Role: 'admin.manager',
        GetIcon(): React.ReactNode {
            return <DeviceHubIcon/>
        }
    },
    {
        Id: 30,
        Name: 'Игры',
        Role: 'admin.manager',
        Rout: 'games',
        GetIcon(): React.ReactNode {
            return <VideogameAssetIcon/>
        }
    },
    {
        Id: 40,
        Name: 'Ордера',
        Role: 'admin.manager',
        Rout: 'orders',
        GetIcon(): React.ReactNode {
            return <GradingIcon/>
        }
    },
    {
        Id: 50,
        Name: 'Заявки',
        Role: 'admin.manager',
        Rout: 'bids',
        GetIcon(): React.ReactNode {
            return <BookmarkAddIcon/>
        }
    },
    {
        Id: 60,
        Name: 'Банеры',
        Role: 'admin.manager',
        Rout: 'banners',
        GetIcon(): React.ReactNode {
            return <PanoramaIcon/>
        }
    },
    {
        Id: 70,
        Name: 'Финансы',
        Role: 'admin.manager',
        Rout: 'payment-methods',
        GetIcon(): React.ReactNode {
            return <AccountBalanceWalletIcon/>
        }
    },
    {
        Id: 75,
        Name: 'Юнит-экономика',
        Role: 'admin.manager',
        Rout: 'unit-economics',
        GetIcon(): React.ReactNode {
            return <QueryStatsIcon/>
        }
    },
    {
        Id: 76,
        Name: 'Рекламные кампании',
        Role: 'admin.manager',
        Rout: 'ad-campaigns',
        GetIcon(): React.ReactNode {
            return <CampaignIcon/>
        }
    },
    {
        Id: 74,
        Name: 'Поставщики',
        Role: 'admin.manager',
        GetIcon(): React.ReactNode {
            return <StorefrontIcon/>
        },
        Items: [
            {
                Id: 741,
                Name: 'Управление',
                Rout: 'external-markets',
                Role: 'admin.manager',
            },
            {
                Id: 742,
                Name: 'Аналитика',
                Rout: 'external-markets/analytics',
                Role: 'admin.manager',
            }
        ]
    },
    {
        Id: 77,
        Name: 'Комиссии',
        Role: 'admin.manager',
        Rout: 'commissionRules',
        GetIcon(): React.ReactNode {
            return <PriceCheckIcon/>
        }
    },
    {
        Id: 78,
        Name: 'Блокировки',
        Role: 'admin.manager',
        Rout: 'user-blocks',
        GetIcon(): React.ReactNode {
            return <BlockIcon/>
        }
    },
    {
        Id: 79,
        Name: 'Черный список',
        Role: 'admin.manager',
        Rout: 'access-blacklist',
        GetIcon(): React.ReactNode {
            return <GppBadIcon/>
        }
    },
    {
        Id: 80,
        Name: 'Система',
        Role: 'admin.manager',
        Rout: 'system',
        GetIcon(): React.ReactNode {
            return <WorkHistoryIcon/>
        }
    }
];

